import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, extendTheme, ColorModeScript } from "@chakra-ui/react";
import App from "./App";
import { WalletProvider } from "./walletConnect";
import ErrorBoundary from "./ErrorBoundary";
import { logFrontendError } from "./utils/logger";

const config = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

const theme = extendTheme({ config });

// Attach global logging for unexpected runtime issues
window.addEventListener("error", (e) => {
  logFrontendError(`Global error: ${e.message}`, e.error?.stack || "");
});

window.addEventListener("unhandledrejection", (e) => {
  logFrontendError(
    `Unhandled promise rejection: ${e.reason}`,
    e.reason?.stack || ""
  );
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChakraProvider theme={theme}>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <WalletProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </WalletProvider>
  </ChakraProvider>
);

// Register SW only in production, over HTTPS
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const swUrl = "/service-worker.js";
    navigator.serviceWorker.register(swUrl).catch(console.error);
  });
}
